export default __webpack_public_path__ + "static/media/LI.349cc2dc.png";